/**
 * Get currency symbol based on contract data
 * @param {Object} userInfo - User info object from invoiceData
 * @returns {string} Currency symbol (₽ for RU, ₸ for KZ)
 */
export function getCurrencySymbol(userInfo) {
    return userInfo?.is_kz ? '₸' : '₽';
}

/**
 * Get currency code based on contract data
 * @param {Object} userInfo - User info object from invoiceData
 * @returns {string} Currency code ('KZT' for Kazakhstan, 'RUB' for Russia)
 */
export function getCurrencyCode(userInfo) {
    return userInfo?.is_kz ? 'KZT' : 'RUB';
}

/**
 * Get currency name based on contract data
 * @param {Object} userInfo - User info object from invoiceData
 * @returns {string} Currency name ('тенге' for Kazakhstan, 'рублей' for Russia)
 */
export function getCurrencyName(userInfo) {
    return userInfo?.is_kz ? 'тенге' : 'рублей';
}




